import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { getDefaultCategory, getDefaultStore } from "@utils/ipetbooking-get-default";
import { resolveHomeRedirect } from "@router-utils/resolve-home-redirect";
import { redirectIfHotelDisabled } from '@router-utils/require-hotel-enabled'
import { redirectIfSiteDisabled } from '@router-utils/require-site-enabled'

export default [
  // ===
  // 首頁
  // ===
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (!store.state.merchant?.currentMerchant) {
            await store.dispatch('merchant/init')
          }

          const homeRedirect = resolveHomeRedirect(store.getters)
          if (homeRedirect) {
            return next(homeRedirect)
          }

          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          const [
            currentService
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationPrice', {
              storeAlias: getDefaultStore(routeTo.query.serviceStore),
              categoryAlias: getDefaultCategory(routeTo.query.serviceCategory)
            }),
          ]);

          routeTo.params.serviceList = currentService.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      serviceList: route.params.serviceList || []
    }),
  },
  // ===
  // 使用細則＆隱私權條款
  // ===
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/Privacy/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
  // ===
  // 住宿契約與退款說明
  // ===
  {
    path: '/hotel-terms',
    name: 'hotel-terms',
    component: () => lazyLoadView(import('@views/HotelTerms/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
  // ===
  // 美容契約與退款說明
  // ===
  {
    path: '/service-terms',
    name: 'service-terms',
    component: () => lazyLoadView(import('@views/ServiceTerms/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfSiteDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
  // ===
  // 收不到簡訊驗證碼？(一次性密碼OTP)怎麼辦
  // ===
  {
    path: '/newsletter-tip',
    name: 'newsletter-tip',
    component: () => lazyLoadView(import('@views/NewsletterTip/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
]
